import React, { useCallback, useEffect, useState } from 'react'
import MasterComponentWraper from '../../Backend/MasterComponentWraper'
import NavigationHeder from '../../Navigations/NavigationHeder'
import ButtonNew from '../../inc/ButtonNew'
import AgGridNew from '../../grid/ag/ag-grid-new'
import ExternalSystemApiFormsPopup from './ExternalSystemApiFormsPopup'
import { useNavigate } from 'react-router-dom'
import Api from '../../../inc/Api'
import Settings from '../../../inc/Settings'
import Helper from '../../../inc/Helper'
import { getPopupMessageBasedOnStatus } from '../../../inc/Validation'
import { getLabelFromDropdown, gridLinkValueFormat } from '../../grid/ag/commonFunctions/GridCommonFunctions'
import DatepickerFunctions from '../../../inc/DatepickerHelper'
import CommonAPICalls from '../Common Integration Calls/CommonApiCalls'
import SimpleDropdown from '../../grid/ag/cellEditor/SimpleDropdown'

let gridApi = null;
const ExternalSystemApiFormsListings = () => {
  const [openPopupView, setOpenPopupView] = useState(false);
  const [appMaster, setAppMaster] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {  
    fetchDataForAppMaster();
  }, [])

  const fetchDataForAppMaster = async () => {
    const apiCalls = new CommonAPICalls();
    try {
      const systemAppMasterResponse = await apiCalls.getSystemAppMaster();
      if (systemAppMasterResponse) {
        setAppMaster(systemAppMasterResponse);
      };
    } catch (error) { 
      setAppMaster([]); 
    }
  }

  const onClickRedirectToDetailView = (event) => {   
    if(event.colDef.field === 'api_name') { 
      navigate(`/edit-external-system-api/${event?.data?.external_api_id}`)
    }
  }

  const onClickPopupView = () => {
    setOpenPopupView(true);
  }

  const onDeleteIntegrationDocument = useCallback(async (element) => { 
    let api = Api;
    api.setUserToken();
    
    let delDocument_ID = element?.data?.external_api_id;

    try {
      const res = await api
      .axios()
      .delete(Settings.apiAppUrl+`/external-api/${delDocument_ID}/`)

      const rowNode = gridApi?.getRowNode(delDocument_ID)
      
      if (rowNode) {
        rowNode.setSelected(false)
      }
      
      setTimeout(() => {
        const transaction = { remove: [element.data] }
        gridApi?.applyServerSideTransaction(transaction) 
      }, 200);

      gridApi?.refreshServerSide({ purge: true })
      gridApi?.deselectAll();
      
      Helper.alert(res?.data?.message || 'External system Api deleted successfully', 'success')
    } catch (err) {
      getPopupMessageBasedOnStatus(err)
    }
  }, []);

  const reloadParentGrid = () => {
    gridApi?.refreshServerSide({ purge: true });
    gridApi?.deselectAll();
  };

  const gridColumnHeaders = [
    {field:'api_name', filter: 'agTextColumnFilter', headerName:'Api name', editable:false, cellRenderer: (params) => gridLinkValueFormat(params) },
    {field:'api_endpoint', headerName:'Api endpoint', editable: false }, 
    {field:'auth_method', headerName:'Auth method', editable: false },
    {field:'additional_info', headerName:'Additional info', editable: false },
    {
      field: 'app',
      headerName: 'App',
      editable: false, 
      isAllowZero:true,
      cellEditor: SimpleDropdown,
      minWidth:180,  
      cellEditorParams: {
        values: appMaster
      },
      cellDataType:false,
      valueFormatter: (params) => getLabelFromDropdown(params)
    }, 
    {field:'sequence', headerName:'Sequence', editable: false }, 
    {field:'created_by', headerName:'Created by', editable: false },
    {field:'created_datetime', valueFormatter: (params) => params.value ? DatepickerFunctions.convertDateTimeFromDataBase(params.value) : '-', headerName:'Created date time', editable: false },
    {field:'modified_by', headerName:'Modified by', editable: false },
    {field:'modified_datetime', valueFormatter: (params) => params.value ? DatepickerFunctions.convertDateTimeFromDataBase(params.value) : '-', headerName:'Modified date time', editable: false }
  ];

  return (
    <div className='container-fluid'>
      <NavigationHeder hideMoreBtn={true} backUrl='/system-integration' title={'External System Api'}>
        <ButtonNew onClick={onClickPopupView} title={'New'}  />
      </NavigationHeder>

      <AgGridNew
        apiUrl={Settings.apiAppUrl+'/external-api/'} 
        pagination={false}
        columnDefs={gridColumnHeaders} 
        hideAddBtn={true}
        height={500}
        uniqueField={'external_api_id'}
        onCellClicked={onClickRedirectToDetailView}
        handleDeleteSelectedRows={onDeleteIntegrationDocument}
        onGridReady={(params) => gridApi = params?.api} 
        gridId={"operation_mapping_forms_listing_grid"}
      />

      {openPopupView && <ExternalSystemApiFormsPopup reloadParentGrid={reloadParentGrid} setClosePopupViewModal={setOpenPopupView} />}
    </div>
  )
}

export default (MasterComponentWraper(ExternalSystemApiFormsListings))